import ChartEvidenceBadge from "./ChartEvidenceBadge";
import { formatChartValue } from "./formatChartValue";

export default function ChartDataTable({ fields = [], entries = [] }) {
  return (
    <div className="overflow-x-auto rounded-2xl border border-neutral-200">
      <table className="min-w-full border-collapse bg-white text-left text-sm">
        <caption className="sr-only">Source-linked data used in the infographic</caption>
        <thead className="bg-neutral-950 text-white">
          <tr>
            {fields.map((field) => <th key={field.key} scope="col" className="whitespace-nowrap px-4 py-3">{field.label}</th>)}
            <th scope="col" className="whitespace-nowrap px-4 py-3">Record notes</th>
            <th scope="col" className="whitespace-nowrap px-4 py-3">Evidence</th>
            <th scope="col" className="whitespace-nowrap px-4 py-3">Source</th>
          </tr>
        </thead>
        <tbody>
          {entries.length ? entries.map((entry, index) => (
            <tr key={`${entry.robot || entry.company || entry.stage || entry.layer || "row"}-${index}`} className="border-t border-neutral-200 align-top even:bg-neutral-50/70">
              {fields.map((field) => <td key={field.key} className="min-w-32 px-4 py-3 text-neutral-700">{formatChartValue(entry, field.key)}</td>)}
              <td className="min-w-64 px-4 py-3 text-neutral-700">{[...new Set([entry.notes, entry.runtimeCondition, entry.configuration].filter(Boolean))].join(" ") || "No additional notes"}</td>
              <td className="px-4 py-3"><ChartEvidenceBadge status={entry.evidence} /></td>
              <td className="min-w-52 px-4 py-3">
                {entry.sourceUrl ? <a href={entry.sourceUrl} target="_blank" rel="noreferrer" className="font-bold text-blue-700 hover:underline">{entry.sourceName || "Open source"}</a> : <span className="text-neutral-500">Awaiting verified source</span>}
                {entry.sourceDate && <span className="mt-1 block text-xs text-neutral-500">Published {entry.sourceDate}</span>}
                {entry.accessedDate && <span className="mt-1 block text-xs text-neutral-500">Checked {entry.accessedDate}</span>}
              </td>
            </tr>
          )) : (
            <tr><td colSpan={fields.length + 3} className="px-5 py-10 text-center text-neutral-500">No records to display</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
